// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  modId: __t.u64().primaryKey().name("mod_id"),
  stationKey: __t.string().name("station_key"),
  commodity: __t.string(),
  mult: __t.f32(),
  reason: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
